<template>
  <div class="personal-center">
    <div
      v-loading="isLoading"
      class="person-center-info"
    >
      <div class="ch-title">
        個人中心
      </div>
      <div class="ch-person-center-card">
        <div class="ch-form-img">
          <el-image
            v-if="userImg"
            :key="userImg"
            :src="userImg"
            :lazy="lazyLoadingAva"
            fit="fill"
            class="ch-image"
          />
        </div>
        <div class="ch-person-center-row">
          <div class="ch-person-center-col-r1 ch-widthr1">
            <div class="ch-person-center-text">
              {{ userInfo.name }}
            </div>
            <div class="ch-person-center-text-en">
              {{ userInfo.nameEN }}
            </div>
          </div>
          <div
            class="ch-person-center-col-r2 ch-widthr2"
            style="margin-left: 200px"
          >
            <div class="ch-person-center-info-item">
              <div class="ch-person-center-info-item-label">
                角色：
              </div>
              <div class="ch-person-center-info-item-text">
                {{ userInfo.roleName }}
              </div>
            </div>
          </div>
          <div class="ch-person-center-col-r2 ch-person-row-row">
            <div class="ch-person-center-info-item">
              <div class="ch-person-center-info-item-label">
                賬戶：
              </div>
              <div class="ch-person-center-info-item-text">
                {{ userInfo.departmentName }}
              </div>
            </div>
            <div
              class="ch-person-center-info-item"
              style="margin-left: 30px"
            >
              <div class="ch-person-center-info-item-label" />
              <div class="ch-person-center-info-item-text-2">
                <span
                  v-if="userInfo.roleList.length > 1"
                  class="ch-person-point-button"
                  @click="changeDepartment"
                >切換賬戶</span>
              </div>
            </div>
          </div>
        </div>
        <div class="ch-person-center-row">
          <div class="ch-person-center-col-r1 ch-widthr1">
            <!-- openAvatarDialog -->
            <el-button
              type="primary"
              class="ch-button-blue"
              @click="beforeAvatarUpload('userImage')"
            >
              {{ this.userInfo.imagePath ? '更改頭像' : '上傳頭像' }}
            </el-button>
          </div>
          <div
            class="ch-person-center-col-r2 ch-widthr2"
            style="margin-left: 200px"
          >
            <div class="ch-person-center-info-item">
              <div class="ch-person-center-info-item-label">
                電郵：
              </div>
              <div class="ch-person-center-info-item-text">
                {{ userInfo.email }}
              </div>
            </div>
          </div>
          <div
            class="ch-person-center-col-r2 ch-person-row-row guide-page"
            style="max-width: 20%"
          >
            <div class="ch-person-center-info-item">
              <div class="ch-person-center-info-item-label">
                電話：
              </div>
              <div
                v-if="userInfo.loginTelephone"
                class="ch-person-center-info-item-text"
              >
                {{ userInfo.loginTelephone }}
              </div>
              <div
                v-else
                class="ch-person-point-button"
                @click="openDialog"
              >
                綁定手機
              </div>
            </div>
            <!-- 首次进入 引导设置 -->
            <div
              class="ch-person-center-info-item"
              style="margin-left: 30px"
            >
              <div class="ch-person-center-info-item-label" />
              <div class="ch-person-center-info-item-text-2">
                <span
                  v-if="userInfo.loginTelephone"
                  class="ch-person-point-button"
                  @click="unbindPhone"
                >解除綁定</span>
              </div>
            </div>
          </div>
          <div class="ch-person-center-col-r3">
            <span>參與測試版功能體驗</span>
            <el-tooltip placement="top">
              <div slot="content">
                要體驗新功能或優化時，可以參加測試版。<br>這樣就能提前享受到最新的功能。
              </div>
              <img
                class="imgTip"
                src="../../assets/hovertip.svg"
                alt=""
              >
            </el-tooltip>
            <el-switch
              v-model="isJoinTestFlight"
              @change="setAccountSwitch"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 聯絡資料 -->
    <div class="person-center-mes">
      <div class="ch-title">
        聯絡資料
      </div>
      <div class="boxmes">
        <!-- 放盤人或管理員角色 -->
        <el-button
          v-if="companyType != 2"
          type="primary"
          :disabled="userInfo.roleID == 4 || disEditBut ||isDisabledPublish"
          class="ch-button-blue dataBtn"
          @click="editUserInfo"
        >
          修改資料
        </el-button>
        <template v-if="showUserInfo">
          <template v-if="userInfoData.isAgent === true">
            <div
              v-for="(item, index) in userData"
              :key="index"
              class="conDiv"
            >
              <div :class="['conDivBox', { rightConIma: (item.itemEnCode == 'weChatQRCode' || item.itemEnCode == 'agentCardPath') && item.itemVal }]">
                <span class="leftTit">{{ item.itemCulture }}</span>
                <span
                  v-if="item.itemEnCode == 'weChatQRCode' || item.itemEnCode == 'agentCardPath'"
                  class="rightCon"
                >
                  <span v-if="item.itemVal">
                    <el-image
                      :key="item.itemVal"
                      :src="item.itemVal"
                      :lazy="lazyLoadingAva"
                      fit="fill"
                      class="ch-image"
                    />
                  </span>
                  <span v-else>-</span>
                </span>
                <span
                  v-else
                  class="rightCon"
                >{{ item.itemVal ? item.itemVal : '-' }}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div
              v-for="(item, index) in userData"
              :key="index"
              class="conDiv"
            >
              <div
                v-if="item.itemEnCode == 'telephone' || item.itemEnCode == 'whatsApp'"
                class="conDivBox"
              >
                <span class="leftTit">{{ item.itemCulture }}</span>
                <span class="rightCon right-agent">{{ item.itemVal ? item.itemVal : '-' }}</span>
              </div>
            </div>
          </template>
        </template>
        <template v-if="!showUserInfo">
          <div class="formSub">
            <el-form
              ref="ruleForm"
              :model="ruleForm"
              :rules="rulesForm"
              label-width="150px"
              class="demo-ruleForm"
            >
              <el-form-item
                label="聯絡電話："
                class="w420"
                prop="telephone"
              >
                <el-select
                  v-model="ruleForm.phoneCode"
                  class="w84"
                  placeholder="+852"
                  filterable
                  no-data-text="暫無數據"
                  @change="isDifferentPhone"
                >
                  <el-option
                    v-for="(item,index) in codeList"
                    :key="index+3"
                    :label="item.codeText"
                    :value="item.code"
                  />
                </el-select>
                <el-input
                  v-model.trim="ruleForm.telephone"
                  class="winput"
                  :disabled="companyCategory == 1"
                  @blur="isDifferentPhone"
                />
                <el-checkbox
                  v-model.trim="ruleForm.isShowWhatsApp"
                  class="wcheck"
                  :disabled="companyCategory == 1"
                  @change="isDifferentPhone"
                >
                  聯絡電話與WhatsApp號碼相同
                </el-checkbox>
              </el-form-item>
              <el-form-item
                label="WhatsApp號碼"
                class="w420"
                prop="whatsApp"
              >
                <el-select
                  v-model="ruleForm.whatsAppCode"
                  class="w84"
                  :disabled="ruleForm.isShowWhatsApp"
                  placeholder="+852"
                  filterable
                  no-data-text="暫無數據"
                >
                  <el-option
                    v-for="(item,index) in codeList"
                    :key="index+3"
                    :label="item.codeText"
                    :value="item.code"
                  />
                </el-select>
                <el-input
                  v-model.trim="ruleForm.whatsApp"
                  class="winput"
                  :disabled="ruleForm.isShowWhatsApp"
                />
              </el-form-item>
              <div
                v-if="userInfoData.isAgent === true"
                class="isAgent"
              >
                <!-- <div class="privateHeight"> -->
                <el-form-item
                  label="國內聯絡電話"
                  class="w420"
                  prop="customerTel"
                >
                  <el-input
                    v-model.trim="ruleForm.customerTel"
                    maxlength="11"
                  />
                  <span class="wcheckTit">(毋須填86)</span>
                </el-form-item>
                <!-- </div> -->
                <!-- 微信qrcode 微信号 -->
                <el-form-item
                  label="WeChat號"
                  class="w420"
                  prop="weChatNo"
                >
                  <el-input
                    v-model.trim="ruleForm.weChatNo"
                    @blur="changeWeCharNo"
                  />
                  <span class="wcheckTit">WeChat號長度限6-20位</span>
                </el-form-item>
                <el-form-item
                  label="WeChat二維碼"
                  prop="weChatcode"
                >
                  <el-input
                    v-show="false"
                    v-model="ruleForm.weChatQRCode"
                  />
                  <el-row>
                    <el-col :span="5">
                      <div
                        :class="['avatar-uploader', !ruleForm.weChatNo || ruleForm.weChatNo.length < 6 || ruleForm.weChatNo.length > 20 ? 'none' : '']"
                        @click="beforeAvatarUpload('weChatQRCode')"
                      >
                        <!-- <img v-if="ruleForm.weChatQRCode" :src="pub.imgResize(ruleForm.weChatQRCode, 'user')" class="avatar" /> -->
                        <el-image
                          v-if="ruleForm.weChatQRCode"
                          :src="pub.imgResize(ruleForm.weChatQRCode, 'user')"
                          :lazy="lazyLoadingAva"
                          fit="fill"
                          class="ch-image"
                        />
                        <i
                          v-else
                          class="el-icon-plus avatar-uploader-icon"
                        />
                      </div>
                    </el-col>
                    <el-col :span="18">
                      <label :class="['photoTip', 'explain']">
                        <p>輸入WeChat號，請同步上傳WeChat二維碼</p>
                        <br>
                        <p>支援格式：JPG, JPEG, PNG）</p>
                      </label>
                    </el-col>
                  </el-row>
                </el-form-item>
                <template v-if="!isUseHideAgentLicensePlate">
                  <el-form-item
                    label="個人地產代理牌照"
                    class="w520"
                    prop="license"
                  >
                    <el-input
                      v-model.trim="ruleForm.license"
                      placeholder="代理牌照格式為：E-123456 / S-123456"
                      maxlength="20"
                    />
                  </el-form-item>
                  <el-form-item
                    label="上傳代理證"
                    prop="agentCardPath"
                  >
                    <el-input
                      v-show="false"
                      v-model="ruleForm.agentCardPath"
                    />
                    <el-row>
                      <el-col :span="5">
                        <div
                          :class="['avatar-uploader']"
                          @click="beforeAvatarUpload('agentCardPath')"
                        >
                          <!-- <img v-if="ruleForm.agentCardPath" :src="pub.imgResize(ruleForm.agentCardPath, 'user')" class="avatar" /> -->
                          <el-image
                            v-if="ruleForm.agentCardPath"
                            :src="pub.imgResize(ruleForm.agentCardPath, 'user')"
                            :lazy="lazyLoadingAva"
                            fit="fill"
                            class="ch-image"
                          />
                          <i
                            v-else
                            class="el-icon-plus avatar-uploader-icon"
                          />
                        </div>
                      </el-col>
                      <el-col :span="18">
                        <label :class="['photoTip', 'explain']">
                          <p>支援格式：JPG, JPEG, PNG）</p>
                        </label>
                      </el-col>
                    </el-row>
                  </el-form-item>
                  <el-form-item
                    label="地產牌照屆滿日期"
                    class="w380"
                    prop="agentCardExpireTime"
                  >
                    <!-- value-format="timestamp" -->
                    <el-date-picker
                      v-model="ruleForm.agentCardExpireTime"
                      format="yyyy/MM/dd"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="請選擇日期"
                    />
                  </el-form-item>
                </template>

                <div class="privateHeight">
                  <el-form-item
                    label="代理個人署名或特別服務"
                    class="w600"
                  >
                    <el-input
                      v-model="ruleForm.signature"
                      :rows="3"
                      maxlength="200"
                      type="textarea"
                    />
                    <label class="photoTip">輸入限制200字</label>
                  </el-form-item>
                </div>
              </div>
              <div class="btn">
                <el-button
                  type="primary"
                  @click="submitForm('ruleForm')"
                >
                  儲存
                </el-button>
                <el-button @click="getBack">
                  返回
                </el-button>
              </div>
            </el-form>
          </div>
        </template>
      </div>
    </div>
    <!--
    <div class="ch-form-item" style="padding-left: 20px;margin-top: 20px">
      <el-button type="primary" class="ch-button-blue-2" @click="changePassword">修改密碼</el-button>
      <el-button type="primary" class="ch-button-grey" @click="logout">登出</el-button>
    </div>-->
    <!-- 绑定手机-->
    <el-dialog
      :title="title"
      :visible.sync="open"
      width="500px"
      :modal-append-to-body="false"
    >
      <el-form
        ref="form"
        v-loading="loadingBindTelephone"
        :model="form"
        :rules="rules"
        inline
        label-width="90px"
        label-position="right"
      >
        <div class="ch-form-item">
          <el-form-item prop="loginTelephone">
            <span
              slot="label"
              class="ch-form-text-4"
            >電話號碼:</span>
            <el-input
              v-model="form.loginTelephone"
              class="ch-form-item-input"
            />
          </el-form-item>
        </div>
        <div class="ch-form-item">
          <el-form-item prop="verifyCode">
            <span
              slot="label"
              class="ch-form-text-3"
            >驗證碼:</span>
            <el-input
              v-model="form.verifyCode"
              class="ch-form-item-input"
            />
          </el-form-item>
          <span style="float: right">
            <el-button
              v-loading="loadingVeriCode"
              type="primary"
              class="ch-button-big"
              :element-loading-text="loadingVeriCodeSeconds + '秒后請重試'"
              :element-loading-spinner="loadingIcon"
              @click="sendVerifyCode"
            >發送驗證碼</el-button>
          </span>
        </div>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="closeDialog">取 消</el-button>
        <el-button
          class="ch-button-left"
          type="primary"
          @click="bindPhone"
        >確 認</el-button>
      </span>
    </el-dialog>

    <!-- 上传头像组件2 -->
    <el-dialog
      v-loading="loadingAvatar"
      :title="titleAvatar"
      :visible.sync="openAvatar"
      width="480px"
    >
      <div slot="default">
        <AvatarCropper
          ref="upImg"
          :up-source="upSource"
          @changeDis="changeDis"
          @getFileData="synchronizeAvatar"
        />
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="closeAvatarDialog">取 消</el-button>
        <el-button
          type="primary"
          :disabled="showBtn"
          @click="uploadAvatar"
        >確認</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AvatarCropper from '../../components/AvatarCropper/index';
export default {
    name: 'PersonalCenter',
    components: { AvatarCropper },
    computed: {
        ...mapGetters(['userInfo']),
        userImg() {
            return this.userInfoData.imagePath ? this.pub.imgResize(this.userInfoData.imagePath, 'user') : this.defaultAvatar;
        },
        userData() {
            let userData=[]
            if(this.isUseHideAgentLicensePlate){
                userData = ['telephone', 'whatsApp', 'customerTel', 'weChatNo', 'weChatQRCode', 'signature'];
            }else{
                userData = ['telephone', 'whatsApp', 'customerTel', 'weChatNo', 'weChatQRCode', 'license', 'agentCardPath', 'agentCardExpireTime', 'signature'];
            }
            const nameMap = {
                telephone: '放盤顯示聯絡電話',
                whatsApp: 'WhatsApp號碼',
                customerTel: '國內聯絡電話',
                weChatNo: 'WeChat號',
                weChatQRCode: 'WeChat二維碼',
                license: '個人地產代理牌照',
                agentCardPath: '上傳代理證',
                agentCardExpireTime: '地產牌照屆滿日期',
                signature: '代理個人署名或特別服務'
            };

            const result = userData.map(key => {
                let value = this.userInfoData[key];
                if(key == 'whatsApp'){
                    if(this.userInfoData[key] && this.userInfoData.whatsAppCode){
                        value = '+'+this.userInfoData.whatsAppCode +' '+ this.userInfoData[key]
                    }else{
                        value= ''
                    }
                }
                if(key == 'telephone'){
                    if(this.userInfoData.phoneCode && this.userInfoData[key]){
                        value = '+'+this.userInfoData.phoneCode+' '+this.userInfoData[key]
                    }else{
                        value= ''
                    }
                }
                if (key == 'weChatQRCode' || key == 'agentCardPath') {
                    value = this.userInfoData[key] ? this.pub.imgResize(this.userInfoData[key], 'user') : '';
                }    
                if(key == 'agentCardExpireTime' && this.userInfoData[key]){
                    if(this.userInfoData[key].indexOf('0001-01-01')){
                        value = this.userInfoData[key].split('T')[0];  
                    }else{
                        value= ''
                    }
                }
                return { itemCulture: nameMap[key], itemVal: value, itemEnCode: key };
            });
            return result;
        }
    },
    data() {
        let agentCardExpireTime = (rule, value, callback) => {
            if (value === '0001-01-01T00:00:00' || !value) {
                callback(new Error('請選擇地產牌照屆滿日期'));
            } else {
                callback();
            }
        };
        let whatsApp = (rule, value, callback) => {
            let eArr = ['853','65']
            let nArr = ['886','66','60','61']
            let tArr = ['81','1','44']
            let regExp = ''
            if(this.ruleForm.whatsAppCode == '852'){
                regExp = /^[2-9]\d{7}$/;//hk
            }else if(this.ruleForm.whatsAppCode == '86'){
                regExp = /^1[3|4|5|7|8|6|9][0-9]\d{8}$/; //大陆
            }else if(eArr.includes(this.ruleForm.whatsAppCode) ){
                regExp = /^\d{8}$/
            }else if(nArr.includes(this.ruleForm.whatsAppCode)){
                regExp = /^\d{9}$/
            }else if(tArr.includes(this.ruleForm.whatsAppCode)){
                regExp = /^\d{10}$/
            }
            if (value !== '' && value !== null && value != undefined && regExp && !regExp.test(value)) {
                return callback(new Error('請輸入正確的WhatsApp號碼'));
            } 
                callback();
            
        };
        let telephone = (rule, value, callback) => {
            let eArr = ['853','65']
            let nArr = ['886','66','60','61']
            let tArr = ['81','1','44']
            let regExp = ''
            if(this.ruleForm.phoneCode == '852'){
                regExp = /^[2-9]\d{7}$/;
            }else if(this.ruleForm.phoneCode == '86'){
                regExp = /^1[3|4|5|7|8|6|9][0-9]\d{8}$/; 
            }else if(eArr.includes(this.ruleForm.phoneCode) ){
                regExp = /^\d{8}$/
            }else if(nArr.includes(this.ruleForm.phoneCode)){
                regExp = /^\d{9}$/
            }else if(tArr.includes(this.ruleForm.phoneCode)){
                regExp = /^\d{10}$/
            }
            if (!value) {
                return callback(new Error('請輸入電話號碼'));
            } else if (regExp && !regExp.test(value)) {
                return callback(new Error('請輸入正確的電話號碼'));
            } 
                callback();
            
        };
        let license = (rule, value, callback) => {
            let regExp = /^[E|S]-\d{6}$/;
            if (!value) {
                return callback(new Error('請輸入個人地產代理牌照'));
            } else if (!regExp.test(value) && value !== '--') {
                return callback(new Error('請按照格式正確輸入個人地產代理牌照'));
            } 
                callback();
            
        };
        let weChatcode = (rule, value, callback) => {
            if (!this.ruleForm.weChatQRCode && this.ruleForm.weChatNo && this.ruleForm.weChatNo.length >= 6 && this.ruleForm.weChatNo.length <= 20) {
                return callback(new Error('請上傳WeChat二維碼'));
            } 
                callback();
            
        };
        let weChatNo = (rule, value, callback) => {
            if (value && value.length && (value.length < 6 || value.length > 20)) {
                return callback(new Error('WeChat號長度限6-20位'));
            } 
                callback();
            
        };
        // 國內電話驗證
        let customerTel = (rule, value, callback) => {
            let regExp = /^1[3|4|5|7|8|6|9][0-9]\d{8}$/;
            if (value !== '' && value !== null && value != undefined && !regExp.test(value)) {
                return callback(new Error('手機號碼格式不正確'));
            } 
                callback();
            
        };
        return {
            isJoinTestFlight:false,
            codeList:[],
            disEditBut: false,
            companyCategory: '',
            isDisabledPublish:false,
            companyType: 0,
            isUseHideAgentLicensePlate:false,
            upSource: 'userImage',
            showBtn: false,
            ruleForm: {
                isAgent: false,
                whatsApp: '',
                telephone: '',
                whatsAppCode:'852',
                phoneCode:'852',
                license: '',
                customerTel: '',
                weChatNo: '',
                weChatQRCode: '',
                agentCardPath: '',
                agentCardExpireTime: '',
                signature: '',
                isShowWhatsApp: true
            },
            userInfoData: {},
            showUserInfo: true,
            isLoading: false,
            open: false,
            openAvatar: false,
            title: '綁定電話',
            titleAvatar: '上傳頭像',
            defaultAvatar: require('../../assets/default-avatar.svg'),
            loadingVeriCode: false,
            loadingVeriCodeSeconds: 60,
            maxLoadingVericodeSeconds: 60,
            loadingBindTelephone: false,
            timer: null,
            loadingIcon: null,
            lazyLoadingAva: true,
            fileUrl: null,
            fileName: '',
            loadingAvatar: false,
            form: {
                loginTelephone: '',
                verifyCode: ''
            },
            rulesForm: {
                agentCardExpireTime: [{ required: true, trigger: 'blur' ,validator: agentCardExpireTime,}],
                agentCardPath: [{ required: true, message: '請上傳代理證', trigger: 'change' }],
                whatsApp: [{ validator: whatsApp, trigger: ['blur', 'change'] }],
                telephone: [{ required: true, validator: telephone, trigger:  ['blur', 'change'] }],
                imagePath: [{ required: true, message: '請上傳頭像', trigger: 'change' }],
                license: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: license
                    }
                ],
                weChatNo: [{ required: false, validator: weChatNo, trigger: 'blur' }],
                weChatcode: [{ required: false, validator: weChatcode, trigger: 'change' }],
                customerTel: [{ required: false, validator: customerTel, trigger: 'blur' }]
            },
            rules: {
                loginTelephone: [
                    {
                        required: true,
                        message: '電話號必輸',
                        trigger: 'blur'
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (!/^[2-9][0-9]{7}$/.test(value)) {
                                callback(new Error(`需輸入非0或1開頭的8位電話數字`));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                verifyCode: [
                    {
                        required: true,
                        message: '驗證碼必輸',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    beforeDestroy() {
        if (this.timer) {
            this.timer = clearInterval(this.timer);
        }
    },
    mounted() {
        this.getPhoneCodeInfo()
        this.getUserInfo();
        this.getCompanyCofig();
        /**引导设置 */
        let steps = [
            {
                element: '.guide-page',
                closeBtnText: '關閉',
                popover: {
                    className: !this.$route.params.initiativeGuide ? 'first-guidance' : 'personal',
                    title: '綁定手機，快捷登錄'
                },
                onNext: () => {
                    // this.driver.reset();
                    this.$router.push('/homepage');
                }
            }
        ];
        if (this.$route.params.guide)
            {setTimeout(() => {
                this.pub.guide(this.Driver, steps);
            }, 500);}
    },
    methods: {
        ...mapActions(['resetVuex']),
        setAccountSwitch(){
            this.axios.post(this.pub.getApi().SetAccountSwitch,{isJoinTestFlight:this.isJoinTestFlight})
        },
        getPhoneCodeInfo(){
            return this.axios.get(this.pub.getApi().GetPhoneCodeInfo).then(res => {
                this.codeList = res.data.result;
            });
        },
        getBack() {
            // 修改資料按鈕回復高亮，重新回到顯示資料頁面
            this.disEditBut = false;
            this.showUserInfo = true;
        },
        submitForm() {
            this.$refs['ruleForm'].validate(valid => { 
                if (valid) {
                    this.axios.post(this.pub.getApi().UpdateSelf, this.ruleForm).then(res => {
                        if (res.data.code === 0 && res.data.result) {
                            this.$message({
                                type: 'success',
                                message: '操作成功!',
                                showClose: true
                            });
                            this.disEditBut = false;
                            this.showUserInfo = true;
                            this.getUserInfo()
                        } else{
                            this.$message({
                                type: 'error',
                                message: '操作失敗，請重試!',
                                showClose: true
                            });
                        } 
                    });
                } else {
                    if (document.getElementsByClassName('el-message').length === 0) {
                        // this.disablePost = false;
                        this.$message({
                            type: 'warning',
                            message: '請完善信息!',
                            showClose: true
                        });
                    }
                }
            });
        },
        changeDis(a) {
            this.showBtn = a;
        },
        openAvatarDialog() {
            this.openAvatar = true;
            this.loadingAvatar = false;
            this.fileUrl = null;
            this.fileList = [];
        },
        beforeAvatarUpload(source) {
            if (source == 'weChatQRCode' && (!this.ruleForm.weChatNo || this.ruleForm.weChatNo.length < 6 || this.ruleForm.weChatNo.length > 20)) {return;}
            this.upSource = source;
            if (source === 'weChatQRCode') {
                this.titleAvatar = '上傳WeChat二維碼';
            } else if (source === 'agentCardPath') {
                this.titleAvatar = '上傳代理證';
            } else {
                this.titleAvatar = '上傳頭像';
            }
            // source == 'weChatQRCode' ? (this.titleAvatar = '上傳WeChat二維碼') : source == 'agentCardPath' ? (this.titleAvatar = '上傳代理證') : (this.titleAvatar = '上傳頭像');
            this.openAvatar = true;
            this.loadingAvatar = false;
            this.fileUrl = null;
        },

        changeWeCharNo() {
            if (this.ruleForm.weChatNo == '') {
                this.ruleForm.weChatQRCode = '';
            }
        },
        isDifferentPhone() {
            if (this.ruleForm.isShowWhatsApp) {
                this.ruleForm.whatsApp = this.ruleForm.telephone;
                this.ruleForm.whatsAppCode = this.ruleForm.phoneCode;
            }
        },
        getCompanyCofig() {
            return this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
                this.companyCategory = res.data.result.companyCategory; //1.中原 2.李嘉格 3.普通用户
                this.isDisabledPublish = res.data.result.isDisabledPublish;
                this.companyType = res.data.result.companyType;
                this.isUseHideAgentLicensePlate = res.data.result.isUseHideAgentLicensePlate
            });
        },
        getUserInfo() {
            return new Promise((resolve, reject) => {
                this.axios.get(this.pub.getApi().GetUserInfo).then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.userInfoData = res.data.result;
                        this.isJoinTestFlight = this.userInfoData.isJoinTestFlight
                        resolve();
                    } else {
                        reject();
                    }
                });
            });
        },
        editUserInfo() {
            this.disEditBut = true;
            this.showUserInfo = false;
            if(this.userInfoData.agentCardExpireTime.indexOf('0001-01-01')){
                this.userInfoData.agentCardExpireTime = this.userInfoData.agentCardExpireTime.split('T')[0];  
            }else{
                this.userInfoData.agentCardExpireTime= ''
            }
            this.userInfoData.whatsAppCode = !this.userInfoData.whatsAppCode ? '852':this.userInfoData.whatsAppCode
            this.userInfoData.phoneCode = !this.userInfoData.phoneCode ? '852':this.userInfoData.phoneCode
            this.ruleForm = JSON.parse(JSON.stringify(this.userInfoData));
        },
        closeAvatarDialog() {
            this.openAvatar = false;
            this.$refs.upImg.resetFile();
        },
        openDialog() {
            this.open = true;
            this.loadingBindTelephone = false;
        },
        closeDialog() {
            this.open = false;
            this.loadingBindTelephone = false;
        },
        changeDepartment() {
            this.$router.push({ name: this.pub.routeNameLists.SelectRole });
        },
        //解绑手机
        async unbindPhone() {
            let result = await this.$confirm('是否確認解除綁定手機號碼？', '解除綁定', {
                confirmButtonText: '確認',
                cancelButtonText: '取消'
            }).catch(() => {
                return;
            });
            if (result !== 'confirm') {
                return;
            }
            let res = await this.axios.get(this.pub.getApi().TelephoneUnbinding);
            if (res.data.code === 0) {
                this.isLoading = true;
                await this.pub.obtainAndSetUserInfo();
                this.isLoading = false;
                this.$message({
                    message: '已成功解綁電話！',
                    type: 'success',
                    showClose: true,
                    duration: 3000
                });
            } else {
                this.$message({
                    message: '解綁失敗，請重試',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
            }
        },
        //绑定手机
        bindPhone() {
            if (this.loadingBindTelephone) {
                return;
            }
            this.$refs.form.validate(async valid => {
                if (valid) {
                    this.loadingBindTelephone = true;
                    let data = {
                        telephone: this.form.loginTelephone,
                        code: this.form.verifyCode
                    };
                    let res = await this.axios.post(this.pub.getApi().TelephoneBindToken, data);
                    if (res.data.code === 0) {
                        await this.pub.obtainAndSetUserInfo();
                        this.loadingBindTelephone = false;
                        await this.$refs.form.resetFields();
                        this.$message({
                            message: '已成功綁定電話！',
                            type: 'success',
                            showClose: true,
                            duration: 2000
                        });
                        this.open = false;
                        this.timer = clearInterval(this.timer);
                        this.loadingVeriCode = false;
                        this.loadingVeriCodeSeconds = this.maxLoadingVericodeSeconds;
                    } else {
                        this.$message({
                            message: '綁定電話失敗！請重試',
                            type: 'error',
                            showClose: true,
                            duration: 3000
                        });
                        this.loadingBindTelephone = false;
                    }
                }
            });
        },
        //发送验证码
        async sendVerifyCode() {
            if (!this.form.loginTelephone) {
                this.$message({
                    message: '電話號必輸',
                    type: 'error',
                    showClose: true,
                    duration: 3000
                });
                return;
            } else if (!/^[2-9][0-9]{7}$/.test(this.form.loginTelephone)) {
                this.$message({
                    message: '需輸入非0或1開頭的8位電話數字',
                    type: 'error',
                    showClose: true,
                    duration: 3000
                });
                return;
            }
            if (this.loadingVeriCode) {
                return;
            }
            this.loadingBindTelephone = true;
            let params = { loginTelephone: this.form.loginTelephone };
            let res = await this.axios.get(this.pub.getApi().RetrieveTelephone, {
                params
            });
            this.loadingBindTelephone = false;
            if (res.data.code === 0) {
                this.$message({
                    message: '已向您手機發送驗證碼,請注意查收！如未收到，請在60s后重試！',
                    type: 'success',
                    showClose: true,
                    duration: 3000
                });
            } else if (res.data.code === 2033) {
                this.$message({
                    message: '該手機號碼已被他人綁定，請重試！',
                    type: 'error',
                    showClose: true,
                    duration: 3000
                });
                return;
            } else {
                this.$message({
                    message: '未成功發送驗證碼！請重試',
                    type: 'error',
                    showClose: true,
                    duration: 3000
                });
                return;
            }
            if (!this.timer) {
                this.loadingVeriCode = true;
                this.timer = setInterval(() => {
                    if (this.loadingVeriCodeSeconds === 0) {
                        this.loadingVeriCode = false;
                        this.loadingVeriCodeSeconds = this.maxLoadingVericodeSeconds;
                        this.timer = clearInterval(this.timer);
                    } else {
                        this.loadingVeriCodeSeconds--;
                    }
                }, 1000);
            }
        },
        changePassword() {
            this.$router.push({ name: this.pub.routeNameLists.ChangePassword });
        },
        logout() {
            this.$confirm('確認要登出本系統？', '登出', {
                confirmButtonText: '確認',
                cancelButtonText: '取消'
            })
                .then(() => {
                    this.$notify.closeAll();
                    this.pub.delCookie('dEVaUDFrZ1kd0RA');
                    this.resetVuex();
                    this.$router.push({ name: this.pub.routeNameLists.Login });
                })
                .catch(() => {});
        },
        synchronizeAvatar(data, fileName) {
            this.fileUrl = data;
            this.fileName = fileName;
        },
        //上传头像
        async uploadAvatar() {
            const formdata = new FormData();
            formdata.append('file', this.fileUrl, this.fileName);
            this.loadingAvatar = true;
            // post上传
            if (this.upSource == 'userImage') {
                let res = await this.axios.post(this.pub.getApi().Upload, formdata);
                if (res.data.code === 0) {
                    let resUpdateAvatar = await this.axios.get(this.pub.getApi().HeadImagePath, { params: { imagePath: res.data.result[0].url } });
                    if (resUpdateAvatar.data.code === 0) {
                        await this.pub.obtainAndSetUserInfo();
                        this.$message({ message: '頭像更換成功！', type: 'success', showClose: true, duration: 3000 });
                        this.openAvatar = false;
                        this.loadingAvatar = false;
                    } else {
                        this.loadingAvatar = false;
                        this.$message({ message: '未成功上傳頭像，請重試！', type: 'error', showClose: true, duration: 3000 });
                    }
                    this.$refs.upImg.resetFile();
                } else {
                    this.loadingAvatar = false;
                    this.$message({ message: '未成功上傳頭像，請重試！', type: 'error', showClose: true, duration: 3000 });
                }
            } else {
                this.axios
                    .post(this.pub.getApi().Upload, formdata)
                    .then(res => {
                        if (res.data.code === 0 && res.data.result) {
                            let uploadSource = this.upSource == 'agentCardPath' ? 'agentCardPath' : 'weChatQRCode';
                            this.ruleForm[uploadSource] = res.data.result[0].url;
                            this.$message({
                                message: this.upSource == 'agentCardPath' ? '代理證上傳成功' : 'WeChat二維碼上傳成功！',
                                type: 'success',
                                showClose: true
                            });
                            this.openAvatar = false;
                            this.loadingAvatar = false;
                            this.fileUrl = null;
                            this.$refs.upImg.resetFile();
                        }
                    })
                    .catch(error => {
                        this.loadingAvatar = false;
                        let errorMes = this.upSource == 'userImage' ? '代理證上傳失敗，請重新上傳' : 'WeChat二維碼上傳失敗，請重新上傳！';
                        this.$message.error(errorMes);
                    });
            }
        }
    }
};
</script>

<style lang="less" scoped>
@widthr1: 100px;
@widthr2: 300px;
@theme-color: #0064ff;
@bgc-grey: #fafafb;

.person-center-mes {
    margin-top: 50px;
    // pointer-events: none; //禁止点击事件
    .boxmes {
        background: #ffffff;
        border-radius: 20px;
        padding: 30px 0px 50px 44px;
        .formSub {
            .w84{
                width:84px
            }
            /deep/.el-input__inner {
                border-radius: 10px !important;
            }
            /deep/.el-form-item__label {
                color: #171725 !important;
            }
            .wcheckTit {
                position: absolute;
                margin-left: 16px;
                width: 168px;
                color: #666666;
            }
            .winput{
                width:176px;
                margin-left:10px;
            }
            .wcheck {
                color: #666666;
                position: absolute;
                margin-left: 16px;
            }
            .photoTip {
                line-height: 20px;
                display: inline-block;
                color: #989898;
            }
            .explain {
                padding: 10px 0;
            }
            .avatar-uploader {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                width: 100px;
                height: 100px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }
            .avatar-uploader .el-upload:hover {
                border-color: #409eff;
            }
            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 100px;
                height: 100px;
                line-height: 100px;
                text-align: center;
            }
        }
        .dataBtn {
            margin-bottom: 20px;
        }
        .conDiv {
            .leftTit {
                display: inline-block;
                min-width: 154px;
                text-align: right;
                color: #171725;
                font-weight: 700;
                font-size: 14px;
                margin-right: 36px;
            }
            .conDivBox {
                height: 36px;
                margin-bottom: 21px;
            }
            .rightConIma {
                height: 150px;
                vertical-align: top;
                .rightCon {
                    vertical-align: top;
                    .ch-image{
                        width:100px;
                        height:100px;
                    }
                }
            }
            .rightCon {
                vertical-align: top;
                max-width:80%;
                display:inline-block;

                font-weight: 700;
                color: #171725;
                font-size: 14px;
            }
            .right-agent{
                vertical-align: bottom;
            }
        }
    }
    .ch-title {
        padding-bottom: 10px;
        font-size: 24px;
        color: #171725;
    }
}
.w420 {
    width: 420px;
}
.w600 {
    width: 600px;
}
.w520 {
    width: 520px;
}
.w380 {
    width: 380px;
}
.ch-widthr1 {
    width: @widthr1;
}
.ch-widthr2 {
    // width: @widthr2;
    width:20%;
}
.personal-center {
    width: 100%;
    text-align: left;

    .ch-title {
        padding-bottom: 10px;
        font-size: 24px;
        color: #171725;
    }
}

.ch-person-row-row {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.ch-person-point-button {
    font-size: 14px;
    color: #0062ff;
    letter-spacing: 0.1px;
    cursor: pointer;
    font-weight: 400;
}

.ch-person-center-card {
    background: #ffffff;
    border-radius: 20px;
    padding: 30px 50px;
}

.ch-person-center-row {
    margin-bottom: 25px;
    margin-top: 25px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .ch-person-center-col-r3{
        padding-top:16px;
        width:20%;
        font-size:14px;
        font-weight:600;
        margin-left:78px;
        .imgTip {
            margin-left:3px;
            margin-right:7px;
            width: 20px;
            height: 20px;
            vertical-align: sub;
        }
    }
    .ch-person-center-col {
        &-r1 {
            margin-left: 5px;
            margin-right: 5px;
        }

        &-r2 {
            margin-left: 5px;
            margin-right: 5px;
        }
    }
}

.ch-person-center-info-item {
    .ch-person-center-info-item-label {
        margin-bottom: 2px;
        font-size: 12px;
        color: #92929d;
        letter-spacing: 0.5px;
        min-height: 16px;
        line-height: 16px;
    }

    .ch-person-center-info-item-text {
        margin-top: 2px;
        font-size: 14px;
        color: #171725;
        letter-spacing: 0.1px;
        min-height: 18px;
        line-height: 18px;
        font-weight: bold;
        &-2 {
            min-height: 18px;
            line-height: 18px;
        }
    }
}

.ch-person-center-text {
    width: 100%;
    font-size: 16px;
    color: #171725;
    text-align: center;
    font-weight: bolder;
}

.ch-person-center-text-en {
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #92929d;
    margin-top: 6px;
    letter-spacing: 0.1px;
    line-height: 12px;
}

.ch-form-img {
    width: 100px;
    height: 100px;
    border-radius: 50px;
    overflow: hidden;
    margin-left: 5px;
    margin-right: 5px;

    .ch-image {
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
        background-color: #eee;
    }
}

.ch-button {
    width: 100px;

    &-blue {
        border: 1px solid #0062ff;
        border-radius: 10px;
        color: #0062ff;
        background: #ffffff;
        width: 100px;
    }

    &-blue-2 {
        border: 1px solid #0062ff;
        border-radius: 10px;
        color: #ffffff;
        background: #0062ff;
        width: 100px;
    }

    &-grey {
        background: #ffffff;
        border: 1px solid #e2e2ea;
        border-radius: 10px;
        color: #696974;
        width: 100px;
    }
}

.ch-form-item {
    .ch-form-item-input {
        width: 220px;
    }
}

/deep/ .el-dialog__wrapper {
    /deep/.el-dialog {
        border-radius: 10px;
        overflow: hidden;
        .el-dialog__header {
            padding: 9px 32px;
            background: @bgc-grey;
            border-bottom: 1px solid #e2e2ea;
            .el-dialog__title {
                line-height: 24px;
                font-size: 16px;
                color: #666666;
                font-weight: 600;
            }
            .el-dialog__header__btn {
                top: 14px;
            }
        }
        .dialog-footer {
            .el-button {
                width: 98px;
                height: 38px;
                border-radius: 10px;
                border-color: #dbdbdb;
                color: #444444;
            }
            .el-button--primary {
                color: #fff;
                background-color: @theme-color;
                border-color: @theme-color;
            }
            .el-button ~ .el-button {
                margin-left: 15px;
            }
        }
    }
}
</style>
